import { IUserSettingsDateTime } from '../../../actions/userObject/settings/dateTimeFormat'
import { IUserObjectStore } from '../index'

export default function(
  state: IUserObjectStore,
  action: IUserSettingsDateTime,
): IUserObjectStore {
  return {
    ...state,
    userObject: {
      ...state.userObject,
      settings: {
        ...state.userObject.settings,
        dateFormat: {
          ...state.userObject.settings.dateFormat,
          date: action.dateFormat,
          hour: action.timeFormat,
        },
      },
    },
  }
}
